<template>
  <v-col class="mt-4">
    <v-card-title>
      <v-row>
        <v-col class="text-center">
          {{ $t('Очередь ценовых предложений') }}
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-iterator
        :items="orders"
        :items-per-page="itemsPerPage"
        disable-sort
        disable-filtering>
      <template v-slot:item="{ item }">
        <v-card
            :key="item.orderId"
            outlined
            :class="item.isOwner && item.isActive
              ? 'order-own'
              : item.isOwner && !item.isActive
                ? 'order-recalled'
                : 'order-diff'">
          <v-card-title>
            <div
                :class="'title-container' + (item.isOwner && item.isActive
                  ? ' own'
                  : item.isOwner && !item.isActive
                    ? ' recalled'
                    : ' diff')">
              <div>
                {{ $t('Время выставления') }}
                <b>
                  {{ item.orderDate ?
                    $moment(item.orderDate).format('DD.MM.YYYY HH:mm:ss')
                    : null }}
                </b>
              </div>
              <div>
                {{ item.isOwner
                  ? (item.isClient ? $t('Клиентская') : $t('Своя'))
                  : null }}
                <btn-icon-tip
                    v-if="!readonly &&
                      item.isOwner &&
                      canRecallOrder &&
                      item.isActive"
                    :icon="item.isActive
                      ? 'clear'
                      : 'block'"
                    icon-color="error"
                    :tip="$t('Отозвать')"
                    @click="openStatusDialog(item.orderId)" />
                <icon-tip
                    v-else
                    :icon="item.isActive
                      ? 'check_circle'
                      : 'block'"
                    :icon-color="item.isActive
                      ? 'success'
                      : 'error'"
                    :tip="$t('Текущий статус: {0}', [ item.isActive
                      ? $t('Активная')
                      : $t('Отозвана') ] )" />
              </div>
            </div>
          </v-card-title>
          <v-card-text>
            <v-row v-if="item.isClient">
              <text-view
                  :display="`Клиент: ${item.clientOrganizationFullName} (ИНН ${item.clientOrganizationInn})`" />
            </v-row>
            <v-row>
              <v-col :cols="item.fileId ? 9 : 12">
                <v-data-table
                    v-if="lot.lotType === LOT_TYPES.REQUEST_OFFERS_DIVISIBLE_VOLUME"
                    :key="item.orderId"
                    :headers="headers3"
                    :items="[ item ]"
                    item-key="positionId"
                    disable-sort-by
                    dense
                    disable-pagination
                    hide-default-footer
                    :locale="systemLocale">
                  <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                  <template v-slot:item.requestedPartsCount="{ item }" dense>
                    {{ item.requestedPartsCount + "/" +item.satisfiedPartsCount }}
                  </template>
                </v-data-table>
                <v-data-table
                    v-else
                    :key="item.orderId"
                    :headers="headers2"
                    :items="item.premiums || []"
                    :items-per-page="nestedItemsPerPage"
                    item-key="positionId"
                    disable-sort-by
                    dense
                    :locale="systemLocale" />
              </v-col>
              <v-col cols="3">
                <v-row
                    v-if="item.fileId"
                    class="px-2 pb-2 pt-0 mt-0"
                    align-content="center">
                  <text-view
                      :cols="10"
                      align-self="center"
                      :label="$t('Прикрепленные документы')"
                      :display="' '" />
                  <v-col cols="2" align-self="center">
                    <btn-icon-tip
                        icon="get_app"
                        :tip="$t('Скачать документ')"
                        @click="getBusinessFile(item.fileId)" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </v-data-iterator>
    <confirm-dialog
        v-if="confirmDialog.show"
        :dialog-prop="confirmDialog"
        @close="closeDialog('confirmDialog')" />
  </v-col>
</template>

<style scoped>
.order-own {
  border: 2px rgb(24, 214, 126) solid !important;
  margin: 10px !important;
}
.order-recalled {
  border: 2px rgb(228, 27, 54) solid !important;
  margin: 10px !important;
}
.order-diff {
  border: 2px rgb(76, 154, 233) solid !important;
  margin: 10px !important;
}

.title-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 3px;
}
.recalled {
  background-color: rgba(228, 27, 54, 0.2);
  border: 1px rgba(228, 27, 54, 0.2) solid !important;
  border-radius: 4px;
}
.own {
  background-color: rgba(24, 214, 126, 0.2);
  border: 1px rgba(24, 214, 126, 0.2) solid !important;
  border-radius: 4px;
}
.diff {
  background-color: rgba(45, 47, 46, 0.2);
  border: 1px rgba(45, 47, 46, 0.2) solid !important;
  border-radius: 4px;
}

::v-deep div.v-expansion-panel {
  padding: 0 !important;
}

::v-deep div.v-expansion-panel-content__wrap {
  padding: 0 !important;
}

::v-deep button.v-expansion-panel-header {
  padding: 0 !important;
}

</style>

<script>
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip'
  import IconTip from '@/components/reused/ui/IconTip.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import { LOT_ORDERS } from '@/constants/store.js'
  import { SESSION_TYPES, LOT_TYPES } from '@/constants/business'
  import { mapActions } from 'vuex'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'

  export default {
    components: {
      ConfirmDialog,
      BtnIconTip,
      IconTip,
      TextView
    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      orders: {
        type: Array,
        required: true
      },
      lot: {
        type: Object,
        default: () => { return {} }
      },
      session: {
        type: Object,
        default: () => { return {} }
      },
      readonly: {
        type: Boolean,
        default: false
      },
      showAdditionalInfo: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        LOT_TYPES,
        isLoading: false,
        itemsPerPage: 10,
        nestedItemsPerPage: 10,
        confirmDialog: {
          additional: null,
          show: false,
          text: null,
          callback: null,
          warning: true
        }
      }
    },
    computed: {
      isFixPremium () {
        return true // this.lot.premiumType === PREMIUM_TYPES.FIX
      },
      headers2 () {
        return [
          { text: this.$t('Предмет договора'), align: 'start', sortable: false, value: 'positionDescription' },
          { text: this.$t(this.isFixPremium ? 'Цена 1 (одной) углеродной единицы (с учетом НДС)' : 'Значение дифференциала'), align: 'start', sortable: false, value: 'premium', width: '25%' },
          { text: this.$t('Общая стоимость торговой процедуры, {0}', [this.lot.currency]), align: 'start', sortable: false, value: 'orderCost' }
        ]
      },
      headers3 () {
        return [
          { text: this.$t(this.isFixPremium ? 'Цена 1 (одной) углеродной единицы (с учетом НДС)' : 'Значение дифференциала'), align: 'center', sortable: false, value: 'premium', width: '25%' },
          { text: this.$t('Количество углеродных единиц (запрошено/удовлетворено)'), align: 'center', sortable: false, value: 'requestedPartsCount' },
          { text: this.$t('Объем в ценовом предложении (всего удовлетворено)'), align: 'center', sortable: false, value: 'satisfiedVolume' }
        ]
      },
      canRecallOrder () {
        // можно отзывать заявки только во время сессии в определенных типах сессий
        // только для торговой процедуры с закрытой формой
        // подачи ценовых предложений и только в период
        // проведения закрытой Торговой сессии
        if (
          this.session.dateStart &&
          this.session.dateEndWithProlongation) {
          const now = this.serverTime
          const start = this.$moment(this.session.dateStart)
          const end = this.$moment(this.session.dateEndWithProlongation)

          return now.isBetween(start, end) &&
            (/* this.session.sessionType === SESSION_TYPES.PRIVATE_TWO_STAGED_OFFERS || */
              this.session.sessionType === SESSION_TYPES.PRIVATE_OFFERS)
        }
        return false
      }
    },
    methods: {
      ...mapActions(LOT_ORDERS.NAMESPACE, {
        changeOrderStatusAction: LOT_ORDERS.ACTIONS.CHANGE_ORDER_STATUS
      }),
      changeOrderStatus: async function (orderStatus) {
        try {
          const model = {
            lotId: this.lot.lotId,
            lotType: this.lot.lotType,
            sessionId: this.session.sessionId,
            // sessionType: this.session.sessionType,
            orderId: orderStatus.orderId,
            status: { isActive: orderStatus.isActive }
          }
          this.isLoading = true
          await this.changeOrderStatusAction(model)
          //  не вызываем здесь перезагрузку списка в расчете на метод updateOrders signalR
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      openStatusDialog: function (orderId) {
        this.confirmDialog.additional = { isActive: false, orderId }
        this.confirmDialog.text = this.$t('Ваша заявка будет {0}. Продолжить?', [this.$t('отозвана')])
        this.confirmDialog.callback = this.changeOrderStatus
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      }
    }
  }
</script>
